import React from 'react';
import Main from '../Layout/Main'
import Section from '../Layout/Section/Section';
import InnerContainer from '../Layout/InnerContainer/InnerContainer';

const PartnerOne = () => (
  <Main>
    <Section customClass="partners">
      <InnerContainer customClass="partnerOne">
        <h1>Partner One</h1>
        <h3>Partner One stuff goes here</h3>
      </InnerContainer>
    </Section>
  </Main>
)

export default PartnerOne
